module.exports = __webpack_public_path__ + "static/animationSlideImage1-3c84df8fa7c4b14fd1bbe92a292d2a7d.png";